import React from 'react';
import axios from 'axios';

const SaleList = ({ sales, fetchSales }) => {
  const handleDelete = async (id) => {
    try {
      await axios.delete(`http://localhost:5000/api/sales/${id}`);
      fetchSales(); // Recargar la lista de ventas
    } catch (err) {
      console.error('Error eliminando venta:', err);
    }
  };

  return (
    <ul>
      {sales.map(sale => (
        <li key={sale.id}>
          {sale.client} - ${sale.amount} ({sale.status})
          <button onClick={() => handleDelete(sale.id)}>Eliminar</button>
        </li>
      ))}
    </ul>
  );
};

export default SaleList;